import React from 'react';

const CommonPoDcInwardNoWrapper = ({ title, value }) => {
    return (
        <div style={{ marginLeft: '20px' }}>
            <span
                style={{
                    fontWeight: '700',
                    borderRadius: '7px',
                    padding: '5px',
                    fontSize: '20px',
                    color: 'purple',
                    border: '1px solid black'
                }}
            >
                {title}: {value}
            </span>
        </div>
    );
};

export default CommonPoDcInwardNoWrapper;
